// extracted by mini-css-extract-plugin
export var modalOrderCall = "modalOrderCall-module--modalOrderCall--ICpkZ";
export var title = "modalOrderCall-module--title--+wu-Y";
export var subTitle = "modalOrderCall-module--subTitle--9AdXV";
export var form = "modalOrderCall-module--form--wD0P3";
export var area = "modalOrderCall-module--area--Pj1mI";
export var closeModal = "modalOrderCall-module--closeModal--qaHIL";